/**
 * Format number with commas
 * @param {number|string} value
 * @param {number} decimals - จำนวนทศนิยม (default: 0)
 * @returns {string} e.g. 1,234,567.89
 */
export function formatComma(value, decimals = 0) {
  const num = Number(value)
  if (isNaN(num)) return '0'
  return num.toLocaleString('en-US', {
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals,
  })
}

/**
 * Format number with abbreviation (K, M, B, T)
 * @param {number|string} value
 * @param {number} decimals - จำนวนทศนิยม (default: 1)
 * @returns {string} e.g. 1.2K, 3.5M, 1B
 */
export function formatAbbreviate(value, decimals = 1) {
  const num = Number(value)
  if (isNaN(num)) return '0'

  const abbreviations = [
    { threshold: 1e12, suffix: 'T' },
    { threshold: 1e9, suffix: 'B' },
    { threshold: 1e6, suffix: 'M' },
    { threshold: 1e3, suffix: 'K' },
  ]

  for (const { threshold, suffix } of abbreviations) {
    if (Math.abs(num) >= threshold) {
      const abbreviated = num / threshold
      const formatted = abbreviated % 1 === 0
        ? abbreviated.toFixed(0)
        : abbreviated.toFixed(decimals).replace(/\.?0+$/, '')
      return formatted + suffix
    }
  }

  return num.toString()
}

export default {
  formatComma,
  formatAbbreviate,
}
